import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROVINCE',
};

export const searchProvinceByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  return RestClient.request({
    method: 'get',
    url: Constants.API_PROVINCE,
    params: {
      search: text,
      limit: pageSize,
      offset: page * pageSize,
    },
  });
};



// WEBPACK FOOTER //
// ./src/redux/provinces/province_actions.js